module.exports = __webpack_public_path__ + "img/profissionais_mask.01b375c6.svg";